import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  withCredentials: true,
});

export const api = {
  // Auth
  exchangeSession: (session_id) => API.post('/auth/session', { session_id }),
  getMe: () => API.get('/auth/me'),
  logout: () => API.post('/auth/logout'),

  // Public
  getBlogs: (params) => API.get('/blog', { params }),
  getBlog: (id) => API.get(`/blog/${id}`),
  getPortfolio: (params) => API.get('/portfolio', { params }),
  getCaseStudies: () => API.get('/case-studies'),
  getJobs: () => API.get('/jobs'),

  // Forms
  submitContact: (data) => API.post('/contact', data),
  subscribeNewsletter: (data) => API.post('/newsletter', data),
  submitApplication: (data) => API.post('/applications', data),

  // Admin
  createBlog: (data) => API.post('/admin/blog', data),
  updateBlog: (id, data) => API.put(`/admin/blog/${id}`, data),
  deleteBlog: (id) => API.delete(`/admin/blog/${id}`),
  createPortfolio: (data) => API.post('/admin/portfolio', data),
  deletePortfolio: (id) => API.delete(`/admin/portfolio/${id}`),
  createCaseStudy: (data) => API.post('/admin/case-studies', data),
  deleteCaseStudy: (id) => API.delete(`/admin/case-studies/${id}`),
  createJob: (data) => API.post('/admin/jobs', data),
  deleteJob: (id) => API.delete(`/admin/jobs/${id}`),
  getContacts: () => API.get('/admin/contacts'),
  getNewsletters: () => API.get('/admin/newsletters'),
  getApplications: () => API.get('/admin/applications'),
};

export default api;
